import React from 'react';
import PropTypes from 'prop-types';

import { Alert, Badge, Card, Col, Row, Table } from 'react-bootstrap';
import dayjs from 'dayjs';

import { DATE_FORMAT_WITH_TIME } from 'lib/constants';

const CutDryImportTrackingOverviewTab = ({ importRun, getStatusBadge, formatDuration }) => {
  return (
    <Row>
      <Col md={6}>
        <Card className="mb-3">
          <Card.Header>
            <h5>Import Information</h5>
          </Card.Header>
          <Card.Body>
            <Table borderless size="sm">
              <tbody>
                <tr>
                  <td>
                    <strong>ID:</strong>
                  </td>
                  <td>{importRun.id}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Import Type:</strong>
                  </td>
                  <td>
                    <Badge variant="info">{importRun.import_type}</Badge>
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Status:</strong>
                  </td>
                  <td>{getStatusBadge(importRun.status)}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Started:</strong>
                  </td>
                  <td>{dayjs(importRun.date_created).format(DATE_FORMAT_WITH_TIME)}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Completed:</strong>
                  </td>
                  <td>
                    {importRun.import_completed_at
                      ? dayjs(importRun.import_completed_at).format(DATE_FORMAT_WITH_TIME)
                      : 'In Progress'}
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>Duration:</strong>
                  </td>
                  <td>{formatDuration(importRun.date_created, importRun.import_completed_at)}</td>
                </tr>
                <tr>
                  <td>
                    <strong>Source File:</strong>
                  </td>
                  <td>
                    {importRun.source_file_presigned_url && (
                      <a
                        href={importRun.source_file_presigned_url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="btn btn-sm btn-outline-primary"
                      >
                        Download Source File
                      </a>
                    )}
                  </td>
                </tr>
              </tbody>
            </Table>
          </Card.Body>
        </Card>
      </Col>
      <Col md={6}>
        <Card className="mb-3">
          <Card.Header>
            <h5>Processing Statistics</h5>
          </Card.Header>
          <Card.Body>
            <Row className="text-center">
              <Col md={3}>
                <div className="mb-3">
                  <h3 className="text-primary">{importRun.total_rows_processed || 0}</h3>
                  <p className="text-muted mb-0">Total Processed</p>
                </div>
              </Col>
              <Col md={3}>
                <div className="mb-3">
                  <h3 className="text-success">{importRun.new_products_created || 0}</h3>
                  <p className="text-muted mb-0">New Products Created</p>
                </div>
              </Col>
              <Col md={3}>
                <div className="mb-3">
                  <h3 className="text-info">{importRun.existing_products_updated || 0}</h3>
                  <p className="text-muted mb-0">Updated Products</p>
                </div>
              </Col>
              <Col md={3}>
                <div className="mb-3">
                  <h3 className="text-warning">{importRun.rejected_rows || 0}</h3>
                  <p className="text-muted mb-0">Rejected Items</p>
                </div>
              </Col>
            </Row>

            {importRun.error_message && (
              <Alert variant="danger" className="mt-3">
                <strong>Error:</strong> {importRun.error_message}
              </Alert>
            )}
          </Card.Body>
        </Card>
      </Col>
    </Row>
  );
};

CutDryImportTrackingOverviewTab.propTypes = {
  importRun: PropTypes.object.isRequired,
  getStatusBadge: PropTypes.func.isRequired,
  formatDuration: PropTypes.func.isRequired,
};

export default CutDryImportTrackingOverviewTab;
